// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addProductWithResult } from "@bg/App/Services/CartService";
import { enablePostalCodeLocationFinder } from "@bg/App/Store/Selectors/PostalCodeSelector";
import { constants } from "@bg/XDL/constants";
import { getLocalStorage } from "@bg/XDL/Utilities";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    chain,
    ExecuteOnSuccessCallback,
    LoadCart,
    SendDataToApi,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";

export const XngSendDataToApi: any = async (props: any) => {
    const isAuth = getSession(props.getState()).isAuthenticated;
    const postalCode = getLocalStorage(constants.localStorage.POSTAL_CODE);
    const postalCodeId = getLocalStorage(constants.localStorage.POSTAL_CODE_ID);

    if (enablePostalCodeLocationFinder(props.getState()) && !isAuth && postalCode && postalCodeId) {
        props.apiParameter.validPostal = true;
    }

    const result = await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

// fetching all cartLines when adding to cart
export const XngLoadCart: any = (props: any) => {
    props.dispatch(loadCurrentCart({ shouldLoadFullCart: true }));
};

export const XngExecuteOnSuccessCallback: any = (props: any) => {
    props.parameter.onComplete?.(props.apiResult);
};

replaceInChain(chain, SendDataToApi, XngSendDataToApi);
replaceInChain(chain, LoadCart, XngLoadCart);
replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
